import './App.css';
import { RouterProvider } from "react-router-dom";
import {router} from "./routes"
function App() {

  // useEffect(() => {
  //   const clearLocalStorage = () => {
  //     localStorage.clear(); // حذف تمامی مقادیر محلی
  //   };

  //   window.addEventListener('beforeunload', clearLocalStorage);

  //   return () => {
  //     window.removeEventListener('beforeunload', clearLocalStorage);
  //   };
  // }, []);

  return (
    <div>
    <RouterProvider router={router} />
   
    </div>
  );
}

export default App;
